import DeleteIcon from "@mui/icons-material/Delete";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Select,
  Stack,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import { alpha } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { visuallyHidden } from "@mui/utils";
import { format, parseISO } from "date-fns";
import PropTypes from "prop-types";
import * as React from "react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  retrieveAllFreightOffersApi,
  retrieveFreightOfferByIdApi,
} from "../../../components/api/FreightOfferApiService";
import {
  retrieveAllShipmentRequestsApi,
  retrieveShipmentRequestByIdApi,
} from "../../../components/api/ShipmentRequestApiService";
import {
  deleteShippingInstructionsApi,
  retrieveAllShippingInstructionsApi,
  retrieveFastFilteredShippingInstructionCostingApi,
  retrieveFastShippingInstructionCostingApi,
  retrieveFilteredShippingInstructionsApi,
  retrieveSelectedShippingInstructionsByIdApi,
  updateShippingInstructionApi,
} from "../../../components/api/ShippingInstructionApiService";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ExportExcel from "../../../utils/excelExport";
import {
  currencies,
  portsOfDischarge,
  portsOfLoading,
  recordStatus,
  shipmentRequestTypes,
  shippedBy,
  shippingInstructionStatus,
} from "../../../utils/menu-items";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ShippingInstructionHistoryButton from "./Dialogs/ShippingInstructionHistoryButton";
import EditShippingInstructionCostDialog from "./Dialogs/EditShippingInstructionCostDialog.js";
import ViewShippingInstructionCostingDialog from "./Dialogs/ViewShippingInstructionCostingDialog.js";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { retrieveAllItemsApi } from "../../../components/api/ItemApiService.js";
import XLSX from "sheetjs-style";
import { useAuth } from "../../../auth/AuthContext.js";
import MyFilters from "../../../components/MyFilters.js";

function descendingComparator(a, b, orderBy) {
  const valueA = a[orderBy]?.toString().toLowerCase() || '';
  const valueB = b[orderBy]?.toString().toLowerCase() || '';

  if (valueB < valueA) {
    return -1;
  }
  if (valueB > valueA) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "editButton",
    disablePadding: true,
    label: "",
  },
  {
    id: "viewButton",
    disablePadding: true,
    label: "",
  },
  {
    id: "historyButton",
    disablePadding: true,
    label: "",
  },
  {
    id: "id",
    numeric: true,
    disablePadding: true,
    label: "ID",
  },
  {
    id: "shipmentRequestType",
    disablePadding: true,
    label: "Type",
  },
  {
    id: "shipmentQuantity",
    disablePadding: true,
    label: "Shipment Quantity",
  },
  {
    id: "siNumber",
    disablePadding: true,
    label: "SI Number",
  },
  {
    id: "siDate",
    disablePadding: true,
    label: "SI Date",
  },
  {
    id: "ata",
    disablePadding: true,
    label: "ATA",
  },
  {
    id: "purchaseOrder",
    disablePadding: true,
    label: "PO",
  },
  {
    id: "poCompany",
    disablePadding: true,
    label: "PO Company",
  },
  {
    id: "poNumber",
    disablePadding: true,
    label: "SAP PO Number",
  },
  {
    id: "salesOrder",
    disablePadding: true,
    label: "SO",
  },
  {
    id: "soCompany",
    disablePadding: true,
    label: "SO Company",
  },
  {
    id: "soNumber",
    disablePadding: true,
    label: "SAP SO Number",
  },
  {
    id: "unitSellingPrice",
    disablePadding: true,
    label: "Unit Selling Price",
  },
  {
    id: "itemID",
    disablePadding: true,
    label: "Item ID",
  },
  {
    id: "supplierGradeMark",
    disablePadding: true,
    label: "Supplier Grade Mark",
  },
  {
    id: "customerGradeMark",
    disablePadding: true,
    label: "Customer Grade Mark",
  },
  {
    id: "crop",
    numeric: true,
    disablePadding: true,
    label: "Crop",
  },
  {
    id: "warehouse",
    disablePadding: true,
    label: "Warehouse",
  },
  {
    id: "destination",
    disablePadding: true,
    label: "Destination",
  },
  {
    id: "pointOfLoading",
    disablePadding: true,
    label: "Point Of Loading",
  },
  {
    id: "pointOfUnloading",
    disablePadding: true,
    label: "Point Of Unloading",
  },
  {
    id: "freightOffer",
    disablePadding: true,
    label: "Freight Offer",
  },
  {
    id: "unitBuyingPrice",
    disablePadding: true,
    label: "Unit Buying Price",
  },
  {
    id: "unitBuyingPriceUsd",
    disablePadding: true,
    label: "Unit Buying Price USD",
  },
  {
    id: "actualUnitBuyingPrice",
    disablePadding: true,
    label: "Actual Unit Buying Price",
  },
  {
    id: "actualUnitBuyingPriceUsd",
    disablePadding: true,
    label: "Actual Unit Buying Price USD",
  },
  {
    id: "supplierInvoiceTotal",
    disablePadding: true,
    label: "AP Total",
  },
  {
    id: "supplierInvoiceTotalUsd",
    disablePadding: true,
    label: "AP Total USD",
  },
  {
    id: "actualFreightPrice",
    disablePadding: true,
    label: "Unit Freight Cost",
  },
  {
    id: "actualFreightPriceUsd",
    disablePadding: true,
    label: "Unit Freight Cost (USD)",
  },
  {
    id: "actualInsuranceCost",
    disablePadding: true,
    label: "Unit Insurance Cost",
  },
  {
    id: "actualInsuranceCostUsd",
    disablePadding: true,
    label: "Unit Insurance Cost (USD)",
  },
  {
    id: "baseUnitStorageCost",
    disablePadding: true,
    label: "Base Unit Storage Cost",
  },
  {
    id: "baseUnitStorageCostUsd",
    disablePadding: true,
    label: "Base Unit Storage Cost USD",
  },
  {
    id: "actualUnitStorageCostUsd",
    disablePadding: true,
    label: "Unit Storage Cost USD",
  },
  {
    id: "actualStorageCostPerKgUsd",
    disablePadding: true,
    label: "Storage Cost Per Kg USD",
  },
  {
    id: "actualTotalCostWithoutStorage",
    disablePadding: true,
    label: "Total Cost Without Storage",
  },
  {
    id: "actualTotalCost",
    disablePadding: true,
    label: "Total Cost + Storage",
  },
  {
    id: "numberOfCartons",
    numeric: true,
    disablePadding: true,
    label: "Number Of Cartons",
  },
  {
    id: "netWeight",
    numeric: true,
    disablePadding: true,
    label: "Net Weight",
  },
  {
    id: "remark",
    numeric: false,
    disablePadding: false,
    label: "Remark",
  },
  {
    id: "referenceSi",
    numeric: false,
    disablePadding: true,
    label: "Reference SI",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "creationTime",
    numeric: false,
    disablePadding: true,
    label: "Creation Time",
  },
  {
    id: "createdBy",
    numeric: false,
    disablePadding: true,
    label: "Created By",
  },
  {
    id: "recordStatus",
    numeric: false,
    disablePadding: false,
    label: "Record Status",
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all desserts",
            }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={
              headCell.id === "id"
                ? {
                    position: "sticky",
                    left: 0,
                    zIndex: 3,
                  }
                : headCell.id === "siNumber"
                ? {
                    position: "sticky",
                    left: 50,
                    zIndex: 3,
                  }
                : null
            }
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const {
    numSelected,
    showFilters,
    setShowFilters,
    rows,
    selected,
    selectedData,
    filterShippingInstruction,
    setFilterShippingInstruction,
    setRows,
  } = props;
  const [deletePopup, setDeletePopup] = useState(false);
  const [showMyShippingInstructions, setShowMyShippingInstructions] = useState(false);
  
const handleExportComparison = async () => {
    if (!selectedData || selectedData.length === 0) {
      toast.error("Please select at least one row to export.");
      return;
    }

    const toastId = toast.loading("Generating Comparison Report...");

    try {
      // 1. Identify Reference SIs
      const refIds = [...new Set(selectedData
        .map(row => row.shipmentRequestreferenceShippingInstructionId)
        .filter(id => id != null))];

      let refSiMap = {};
      if (refIds.length > 0) {
        const response = await retrieveFastFilteredShippingInstructionCostingApi({
          shippingInstructionIdList: refIds,
          recordStatusList: ["ACTIVE"],
        });
        if (response.data) {
          response.data.forEach(si => {
            refSiMap[si.id] = si;
          });
        }
      }

      // 2. Build Data
      const reportData = selectedData.map(row => {
        const refSi = refSiMap[row.shipmentRequestreferenceShippingInstructionId];

        // Logic to calculate base price from Ref SI if applicable (FW type)
        let calculatedBuyingPrice = null;
        if (row.shipmentRequestType?.startsWith('FW') && refSi) {
             const refUsdCosts = [
                  refSi.actualBuyingPriceUsd ? refSi.actualBuyingPriceUsd : refSi.purchaseOrderUsdFinalPrice,
                  refSi.actualInsuranceCostUsd,
                  refSi.actualFreightPriceUsd,
                  refSi.secondFreightCostUsd,
                  refSi.importExportExpenseUsd,
                  refSi.demurrageUsd,
                  refSi.fumigationUsd,
                  refSi.handlingUsd,
                  refSi.debitNoteUsd,
                  -1 * (refSi.creditNoteUsd || 0),
                ];
             calculatedBuyingPrice = refUsdCosts.reduce((sum, v) => sum + (v || 0), 0);
        }

        const getCostData = (si, overrideBuyingPrice = null) => {
          const qty = si?.shipmentQuantity || 0;

          // Calculate storage cost per unit (kg)
          let storageCost = 0;
          if (si?.actualStorageCost) {
             if (si?.actualStoragePricing === "Carton" && si?.shipmentRequestNetWeightPerCase) {
                 storageCost = Number(si.actualStorageCost) / Number(si.shipmentRequestNetWeightPerCase);
             } else {
                 storageCost = Number(si.actualStorageCost);
             }
          }

          const buyingPrice = overrideBuyingPrice !== null 
            ? overrideBuyingPrice 
            : (si?.actualBuyingPriceUsd || si?.purchaseOrderUsdFinalPrice || 0);

          const freight = si?.actualFreightPriceUsd || 0;
          const insurance = si?.actualInsuranceCostUsd || 0;
          const secondFreight = si?.secondFreightCostUsd || 0;
          const impExp = si?.importExportExpenseUsd || 0;
          const demurrage = si?.demurrageUsd || 0;
          const fumigation = si?.fumigationUsd || 0;
          const handling = si?.handlingUsd || 0;
          const debitNote = si?.debitNoteUsd || 0;
          const creditNote = si?.creditNoteUsd ? -1 * si.creditNoteUsd : 0;
          
          const totalUnitCost = buyingPrice + freight + insurance + storageCost + secondFreight + impExp + demurrage + fumigation + handling + debitNote + creditNote;

          const formatNumber = (num) => ({
            v: Number(num || 0),
            t: 'n',
            z: '#,##0.0000'
          });

          return {
            "Selling Price (USD)": si?.salesOrderUsdFinalPrice || 0,
            "Total Selling Price (USD)": formatNumber((si?.salesOrderUsdFinalPrice || 0) * qty),

            "Buying Price (USD)": buyingPrice,
            "Total Buying Price (USD)": formatNumber(buyingPrice * qty),

            "Freight (USD)": freight,
            "Total Freight (USD)": formatNumber(freight * qty),

            "Insurance (USD)": insurance,
            "Total Insurance (USD)": formatNumber(insurance * qty),

            "Storage (USD)": storageCost,
            "Total Storage (USD)": formatNumber(storageCost * qty),

            "2nd Freight (USD)": secondFreight,
            "Total 2nd Freight (USD)": formatNumber(secondFreight * qty),

            "Imp/Exp (USD)": impExp,
            "Total Imp/Exp (USD)": formatNumber(impExp * qty),

            "Demurrage (USD)": demurrage,
            "Total Demurrage (USD)": formatNumber(demurrage * qty),

            "Fumigation (USD)": fumigation,
            "Total Fumigation (USD)": formatNumber(fumigation * qty),

            "Handling (USD)": handling,
            "Total Handling (USD)": formatNumber(handling * qty),

            "Debit Note (USD)": debitNote,
            "Total Debit Note (USD)": formatNumber(debitNote * qty),

            "Credit Note (USD)": creditNote,
            "Total Credit Note (USD)": formatNumber(creditNote * qty),

            "Unit Total Cost (USD)": totalUnitCost,
            "Grand Total Cost (USD)": formatNumber(totalUnitCost * qty)
          };
        };

        const currentCosts = getCostData(row, calculatedBuyingPrice);
        const refCosts = refSi ? getCostData(refSi) : {};

        // Prefix keys
        const currentCostsPrefixed = Object.keys(currentCosts).reduce((acc, key) => {
          acc[`SI ${key}`] = currentCosts[key];
          return acc;
        }, {});

        const refCostsPrefixed = Object.keys(refCosts).reduce((acc, key) => {
          acc[`Ref ${key}`] = refCosts[key];
          return acc;
        }, {});

        return {
          "SI ID": row.id,
          "SI Number": row.finalShippingInstructionNumber,
          "Type": row.shipmentRequestType || "",
          "Quantity": row.shipmentQuantity ? {
            v: Number(row.shipmentQuantity),
            t: 'n',
            z: '#,##0.0000'
          } : "",
          "Ref SI ID": row.shipmentRequestreferenceShippingInstructionId || "",
          "Ref SI Number": row.shipmentRequestreferenceShippingInstructionNumber || "",
          "Debit Note Type": row.debitNoteType || "",
          "Debit Note Remark": row.debitNoteRemark || "",
          "Credit Note Type": row.creditNoteType || "",
          "Credit Note Remark": row.creditNoteRemark || "",
          ...currentCostsPrefixed,
          ...refCostsPrefixed
        };
      });

      // 3.Export 
      
      const worksheet = XLSX.utils.json_to_sheet(reportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Comparison");
      XLSX.writeFile(workbook, "SI_Cost_Comparison.xlsx");

      toast.success("Report generated successfully", { id: toastId });

    } catch (error) {
      console.error(error);
      toast.error("Failed to generate report", { id: toastId });
    }
  };

     const { user, loading } = useAuth();
  
      if (loading) {
      return <div>Loading...</div>;
    }
  
    if (!user) {
      return <div>Not authorized</div>;
    }

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity,
            ),
        }),
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Dialog
        open={deletePopup}
        onClose={() => setDeletePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete {selected.length} order(s)?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              deleteShippingInstructionsApi(selected)
                .then((response) => {
                  console.log(response?.data);
                  toast.success("SI record(s) deleted successfully.");
                })
                .catch((error) => {
                  console.log(error.response?.data);
                  toast.error("SI record(s) could not be deleted.");
                });

              window.location.reload();
            }}
            autoFocus
          >
            Yes
          </Button>
          <Button onClick={() => setDeletePopup(false)}>No</Button>
        </DialogActions>
      </Dialog>

      <Stack direction="row" spacing={1} alignItems={"center"}>
        <Typography
          sx={{ fontWeight: 600, fontSize: "20px" }}
          variant="h6"
          id="tableTitle"
          component="div"
          color="#1E2685"
        >
          Shipping Instruction Costing
        </Typography>

        <Typography></Typography>
        {numSelected > 0 ? (
          <Typography
            sx={{ fontWeight: 200, fontSize: "16px" }}
            color="#1E2685"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>
        ) : (
          <Typography></Typography>
        )}

                <FormControlLabel
          control={
            <Switch
              checked={showMyShippingInstructions}
              onChange={(e) => {
                setShowMyShippingInstructions(e.target.checked);
                if (e.target.checked) {
                  retrieveFastFilteredShippingInstructionCostingApi({
                    ...filterShippingInstruction,
                    currentUser: user?.email,
                  })
                    .then((response) => {
                      setRows(response?.data);
                    })
                    .catch((error) => {
                      console.log(error?.response?.data);
                      toast.error('Failed to filter shipping instructions');
                    });
                } else {
                  retrieveFastFilteredShippingInstructionCostingApi({
                    ...filterShippingInstruction,
                    currentUser: null,
                  })
                    .then((response) => {
                      setRows(response?.data);
                    })
                    .catch((error) => {
                      console.log(error?.response?.data);
                      toast.error('Failed to load shipping instructions');
                    });
                }
              }}
            />
          }
          label="Show Shipping Instructions Assigned To Me"
          sx={{ ml: 2 }}
        />

      </Stack>
      <Stack spacing={1} direction="row" sx={{ mr: 2 }}>
        <Button
          variant="contained"
          onClick={handleExportComparison}
          sx={{ minWidth: "130px" }}
          size="small"
          disabled={numSelected === 0}
        >
          Compare Costs
        </Button>
        <ExportExcel
          excelData={selectedData}
          fileName={"ShippingInstructionExport"}
          buttonLabel="Export Table"
        />
        <Button
          variant="outlined"
          onClick={() => setShowFilters(!showFilters)}
          sx={{ minWidth: "130px", mr: 2 }}
          size="small"
        >
          {showFilters ? "Hide Filters" : "Show Filters"}
        </Button>
      </Stack>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function ShippingInstructionCostingView() {
  const [rows, setRows] = useState([]);
  useEffect(() => retrieveShippingInstructions(), []);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [showFilters, setShowFilters] = useState(false);
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [invoiceData, setInvoiceData] = useState([]);
  const [closeDialogOpen, setCloseDialogOpen] = useState(false);
  const [isEditShippingCostDialogOpen, setIsEditShippingCostDialogOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const handleTextFieldChange = (event) => {
    const { name, value } = event.target;
    setInvoiceData({ ...invoiceData, [name]: value });
  };

  const handleTransshipmentPortChange = (e, index) => {
    const newPorts = [...invoiceData.transshipmentPorts];
    newPorts[index] = e.target.value;
    setInvoiceData({ ...invoiceData, transshipmentPorts: newPorts });
  };

  const handleRemoveTransshipmentPort = (index) => {
    const newPorts = invoiceData.transshipmentPorts.filter(
      (_, i) => i !== index,
    );
    setInvoiceData({ ...invoiceData, transshipmentPorts: newPorts });
  };

  const handleAddTransshipmentPort = () => {
    const newPorts = [...invoiceData.transshipmentPorts, ""];
    setInvoiceData({ ...invoiceData, transshipmentPorts: newPorts });
  };

  const [
    isAdditionalDepartureTimesVisible,
    setIsAdditionalDepartureTimesVisible,
  ] = useState(false);

  const handleDepartureCellClick = () => {
    setIsAdditionalDepartureTimesVisible((prevVisibility) => !prevVisibility);
  };

  const [componentsState, setComponentsState] = useState({
    shipmentRequest: {
      dropdownOpen: false,
      inputValue: "",
    },
    freightOffer: {
      dropdownOpen: false,
      inputValue: "",
    },
    shippingInstruction: {
      dropdownOpen: false,
      inputValue: "",
    },
    item: {
      dropdownOpen: false,
      inputValue: "",
    },
  });

  const updateComponentState = (componentKey, newState) => {
    setComponentsState((prevState) => ({
      ...prevState,
      [componentKey]: {
        ...prevState[componentKey],
        ...newState,
      },
    }));
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const [showPorts, setShowPorts] = useState(false);

  const togglePortsVisibility = () => {
    setShowPorts(!showPorts);
  };

  const [filterShippingInstruction, setFilterShippingInstruction] = useState({
    id: 0,
    shipmentRequestIdList: [],
    freightOfferIdList: [],
    purchaseOrderIdList: [],
    salesOrderIdList: [],
    shippingInstructionIdList: [],
    itemIdList: [],
    transportationContact: "",
    finalShippingInstructionNumber: "",
    cartonNumber: "",
    shippedByList: [],
    billOfLadingNumber: "",
    cmrNumber: "",
    shipperIdList: [],
    consigneeIdList: [],
    notifyIdList: [],
    pointOfLoadingList: [],
    pointOfUnloadingList: [],
    description: "",
    remark: "",
    statusList: [],
    recordStatusList: ["ACTIVE"],
  });

  function retrieveShippingInstructions() {
    retrieveFastShippingInstructionCostingApi()
      .then((response) => {
        setRows(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  const [shipmentRequest, setShipmentRequest] = useState([]);
  const [shipmentRequests, setShipmentRequests] = useState([]);
  const [freightOffer, setFreightOffer] = useState([]);
  const [freightOffers, setFreightOffers] = useState([]);
  const [items, setItems] = useState([]);

  function retrieveShipmentRequestById(id) {
    retrieveShipmentRequestByIdApi(id)
      .then((response) => {
        setShipmentRequest(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }


  function retrieveShipmentRequests() {
    retrieveAllShipmentRequestsApi()
      .then((response) => {
        setShipmentRequests(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

   function retrieveItems() {
     retrieveAllItemsApi()
       .then((response) => {
         setItems(response?.data);
       })
       .catch((error) => console.log(error.response?.data));
   }
  
  function retrieveFreightOffers() {
    retrieveAllFreightOffersApi()
      .then((response) => {
        setFreightOffers(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }
  function retrieveFreightOfferById(id) {
    retrieveFreightOfferByIdApi(id)
      .then((response) => {
        setFreightOffer(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  const [editShippingInstruction, setEditShippingInstruction] = useState({
    visible: false,
    data: null,
    index: null,
  });

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      setSelectedData(rows);
      return;
    } else {
      setSelected([]);
      setSelectedData([]);
    }
  };

  const handleClick = (event, name, row) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    const selectedDataIndex = selectedData.indexOf(row);
    let newSelectedData = [];

    if (selectedDataIndex === -1) {
      newSelectedData = newSelectedData.concat(selectedData, row);
    } else if (selectedDataIndex === 0) {
      newSelectedData = newSelectedData.concat(selectedData.slice(1));
    } else if (selectedDataIndex === selectedData.length - 1) {
      newSelectedData = newSelectedData.concat(selectedData.slice(0, -1));
    } else if (selectedDataIndex > 0) {
      newSelectedData = newSelectedData.concat(
        selectedData.slice(0, selectedDataIndex),
        selectedData.slice(selectedDataIndex + 1),
      );
    }
    setSelectedData(newSelectedData);

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [viewRow, setViewRow] = useState(null);

  const isSelected = (name) => selected.indexOf(name) !== -1;
  const openViewDialog = (row) => { setViewRow(row); setViewDialogOpen(true); };
  const closeViewDialog = () => { setViewDialogOpen(false); setViewRow(null); };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(rows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, rows, editShippingInstruction],
  );

  return (
    <div>
      <Dialog
        open={uploadDialogOpen}
        onClose={() => setUploadDialogOpen(false)}
        aria-labelledby="upload-dialog-title"
      >
        <DialogTitle id="upload-dialog-title">Select File</DialogTitle>
        <DialogContent>
          <Select
            value={selectedOption}
            onChange={handleOptionChange}
            fullWidth
            displayEmpty
          >
            <MenuItem value="" disabled>
              Select an option
            </MenuItem>
            <MenuItem value="accountsReceivableLink">AR Invoice</MenuItem>
            <MenuItem value="supplierInvoiceLink">Supplier Invoice</MenuItem>
            <MenuItem value="insuranceLink">Insurance</MenuItem>
            <MenuItem value="freightLink">Freight</MenuItem>
            <MenuItem value="billOfLadingLink">BL</MenuItem>
            <MenuItem value="weightListLink">Weight List</MenuItem>
            <MenuItem value="cmrLink">CMR</MenuItem>
            <MenuItem value="goodsReceiptNumber">GR</MenuItem>
            <MenuItem value="landedCostNumber">LC</MenuItem>
            <MenuItem value="deliveryNumber">Del</MenuItem>
            <MenuItem value="shippingDetails">Shipping Details</MenuItem>
          </Select>

          {selectedOption === "accountsReceivableLink" && (
            <div>
              <TextField
                label="AR Invoice Link"
                name="accountsReceivableLink"
                value={invoiceData?.accountsReceivableLink}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <a
                href={invoiceData?.accountsReceivableLink}
                target="_blank"
                rel="noreferrer"
              >
                <Button disabled={!invoiceData?.accountsReceivableLink}>
                  See AR Invoice
                </Button>
              </a>
              <TextField
                label="AR Number"
                name="accountsReceivableNumber"
                value={invoiceData?.accountsReceivableNumber}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
            </div>
          )}
          {selectedOption === "supplierInvoiceLink" && (
            <div>
              <TextField
                label="Supplier Invoice Link"
                name="supplierInvoiceLink"
                value={invoiceData?.supplierInvoiceLink}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <a
                href={invoiceData?.supplierInvoiceLink}
                target="_blank"
                rel="noreferrer"
              >
                <Button disabled={!invoiceData?.supplierInvoiceLink}>
                  See Supplier Invoice
                </Button>
              </a>
            </div>
          )}
          {selectedOption === "insuranceLink" && (
            <div>
              <TextField
                label="Insurance Link"
                name="insuranceLink"
                value={invoiceData?.insuranceLink}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <a
                href={invoiceData?.insuranceLink}
                target="_blank"
                rel="noreferrer"
              >
                <Button disabled={!invoiceData?.insuranceLink}>
                  See Insurance
                </Button>
              </a>
            </div>
          )}
          {selectedOption === "freightLink" && (
            <div>
              <TextField
                label="Freight Link"
                name="freightLink"
                value={invoiceData?.freightLink}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <a
                href={invoiceData?.freightLink}
                target="_blank"
                rel="noreferrer"
              >
                <Button disabled={!invoiceData?.freightLink}>
                  See Freight
                </Button>
              </a>
            </div>
          )}
          {selectedOption === "billOfLadingLink" && (
            <div>
              <TextField
                label="BL Number"
                name="billOfLadingNumber"
                value={invoiceData?.billOfLadingNumber}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <TextField
                size="small"
                label="BL Date"
                fullWidth
                name="billOfLadingDate"
                margin="normal"
                value={
                  invoiceData?.billOfLadingDate
                    ? format(
                        parseISO(invoiceData.billOfLadingDate),
                        "yyyy-MM-dd",
                      )
                    : ""
                }
                id="date"
                type="date"
                inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                InputLabelProps={{
                  shrink: true,
                }}
                onKeyDown={(e) => e.preventDefault()}
                onChange={(e) => {
                  handleTextFieldChange(e);
                }}
              />
              <TextField
                label="BL Link"
                name="billOfLadingLink"
                value={invoiceData?.billOfLadingLink}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <a
                href={invoiceData?.billOfLadingLink}
                target="_blank"
                rel="noreferrer"
              >
                <Button disabled={!invoiceData?.billOfLadingLink}>
                  See BL
                </Button>
              </a>
            </div>
          )}
          {selectedOption === "weightListLink" && (
            <div>
              <TextField
                label="Weight List Link"
                name="weightListLink"
                value={invoiceData?.weightListLink}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <a
                href={invoiceData?.weightListLink}
                target="_blank"
                rel="noreferrer"
              >
                <Button disabled={!invoiceData?.weightListLink}>
                  See Weight List
                </Button>
              </a>
            </div>
          )}
          {selectedOption === "cmrLink" && (
            <div>
              <TextField
                label="CMR Number"
                name="cmrNumber"
                value={invoiceData?.cmrNumber}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <TextField
                size="small"
                label="CMR Date"
                fullWidth
                name="cmrDate"
                margin="normal"
                value={
                  invoiceData?.cmrDate
                    ? format(parseISO(invoiceData.cmrDate), "yyyy-MM-dd")
                    : ""
                }
                id="date"
                type="date"
                inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                InputLabelProps={{
                  shrink: true,
                }}
                onKeyDown={(e) => e.preventDefault()}
                onChange={(e) => {
                  handleTextFieldChange(e);
                }}
              />
            </div>
          )}
          {selectedOption === "goodsReceiptNumber" && (
            <TextField
              label="GR Number"
              name="goodsReceiptNumber"
              value={invoiceData?.goodsReceiptNumber}
              onChange={handleTextFieldChange}
              fullWidth
              margin="normal"
            />
          )}
          {selectedOption === "landedCostNumber" && (
            <TextField
              label="LC Number"
              name="landedCostNumber"
              value={invoiceData?.landedCostNumber}
              onChange={handleTextFieldChange}
              fullWidth
              margin="normal"
            />
          )}
          {selectedOption === "deliveryNumber" && (
            <TextField
              label="Del Number"
              name="deliveryNumber"
              value={invoiceData?.deliveryNumber}
              onChange={handleTextFieldChange}
              fullWidth
              margin="normal"
            />
          )}
          {selectedOption === "shippingDetails" && (
            <div>
              <TextField
                label="Booking Number"
                name="bookingNumber"
                value={invoiceData?.bookingNumber}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Shipping Line"
                name="shippingLine"
                value={invoiceData?.shippingLine}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Vessel Name"
                name="vesselName"
                value={invoiceData?.vesselName}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Voyage Number"
                name="voyageNumber"
                value={invoiceData?.voyageNumber}
                onChange={handleTextFieldChange}
                fullWidth
                margin="normal"
              />
              <Button
                variant="contained"
                onClick={togglePortsVisibility}
                style={{ marginBottom: "16px", marginTop: "16px" }}
              >
                Transshipment Ports
              </Button>

              {showPorts && (
                <div>
                  {invoiceData?.transshipmentPorts?.map((port, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <TextField
                        label={`Transshipment Port ${index + 1}`}
                        value={port}
                        onChange={(e) =>
                          handleTransshipmentPortChange(e, index)
                        }
                        fullWidth
                        margin="normal"
                      />
                      <IconButton
                        onClick={() => handleRemoveTransshipmentPort(index)}
                      >
                        <CloseIcon />
                      </IconButton>
                    </div>
                  ))}
                  <IconButton onClick={handleAddTransshipmentPort}>
                    <AddIcon />
                  </IconButton>
                </div>
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUploadDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              console.log(invoiceData);
              updateShippingInstructionApi(invoiceData?.id, invoiceData)
                .then((response) => {
                  toast.success("Shipping Instruction edited successfully.");
                  window.location.reload();
                })
                .catch((error) => {
                  toast.error("Something went wrong.");
                  console.log(error.response.data);
                });
            }}
            color="primary"
          >
            Upload
          </Button>
        </DialogActions>
      </Dialog>

        <>
          {showFilters && (
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-start"
                alignItems="center"
              >
                
                                                    <Autocomplete
                                        multiple
                                        id="outlined-select-shipping-instruction"
                                        disableClearable
                                        open={componentsState.shippingInstruction.dropdownOpen}
                                        onOpen={() => updateComponentState("shippingInstruction", { dropdownOpen: true })}
                                        inputValue={componentsState.shippingInstruction.inputValue}
                                        onInputChange={(event, newInputValue, reason) => {
                                          if (reason === "input") {
                                            updateComponentState("shippingInstruction", { inputValue: newInputValue });
                                          }
                                        }}
                                        options={[
                                          ...rows.filter((shippingInstruction) =>
                                            filterShippingInstruction.shippingInstructionIdList.includes(shippingInstruction.id),
                                          ),
                                          ...rows.filter(
                                            (shippingInstruction) => !filterShippingInstruction.shippingInstructionIdList.includes(shippingInstruction.id),
                                          ),
                                        ]}
                                        getOptionLabel={(option) =>
                                          `${option?.id || ""} - ${option?.finalShippingInstructionNumber || ""} - ${option?.shipmentRequestType || ""} - Buying Grade: ${
                                            option?.purchaseOrderItemId || ""
                                          } - ${
                                            option?.purchaseOrderItemBuyingGrade || ""
                                          } - ${option?.purchaseOrderItemCrop || ""}`
                                        }
                                        value={rows.filter((shippingInstruction) =>
                                          filterShippingInstruction.shippingInstructionIdList.includes(shippingInstruction.id),
                                        )}
                                        onChange={(event, newValue) => {
                                          setFilterShippingInstruction({
                                            ...filterShippingInstruction,
                                            shippingInstructionIdList: newValue
                                            .map((shippingInstruction) => shippingInstruction.id)
                                            .filter((id) => id !== null),
                                          });
                                        }}
                                        renderOption={(props, option, { selected }) => (
                                          <li
                                            {...props}
                                            style={{
                                              ...props.style,
                                              backgroundColor: selected ? "lightblue" : undefined,
                                              fontWeight: selected ? 700 : 400,
                                            }}
                                          >
                                            {`${option?.id || ""} - ${option?.finalShippingInstructionNumber || ""} - ${option?.shipmentRequestType || ""} - Buying Grade: ${
                                              option?.purchaseOrderItemId || ""
                                            } - ${
                                              option?.purchaseOrderItemBuyingGrade || ""
                                            } - ${option?.purchaseOrderItemCrop || ""}`}
                                          </li>
                                        )}
                                        renderInput={(params) => {
                                          const label =
                                          filterShippingInstruction?.shippingInstructionIdList.length > 0
                                              ? `Shipping Instructions Selected (${filterShippingInstruction?.shippingInstructionIdList.length})`
                                              : "Shipping Instrunction";
                                
                                          return (
                                            <TextField
                                              {...params}
                                              label={label}
                                              type="search"
                                              value={componentsState.shippingInstruction.inputValue}
                                              onChange={(e) =>
                                                updateComponentState("shippingInstruction", { inputValue: e.target.value })
                                              }
                                              InputProps={{
                                                ...params.InputProps,
                                                style: { height: 42 },
                                              }}
                                              onBlur={() =>
                                                updateComponentState("shippingInstruction", { dropdownOpen: false })
                                              }
                                            />
                                          );
                                        }}
                                        renderTags={() => null}
                                      />

                <Autocomplete
                  multiple
                  id="outlined-select-po"
                  disableClearable
                  open={componentsState.shipmentRequest.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("shipmentRequest", {
                      dropdownOpen: true,
                    })
                  }
                  inputValue={componentsState.shipmentRequest.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("shipmentRequest", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...shipmentRequests.filter((shipmentRequest) =>
                      filterShippingInstruction.shipmentRequestIdList.includes(
                        shipmentRequest.id,
                      ),
                    ),
                    ...shipmentRequests.filter(
                      (shipmentRequest) =>
                        !filterShippingInstruction.shipmentRequestIdList.includes(
                          shipmentRequest.id,
                        ),
                    ),
                  ]}
                  getOptionLabel={(option) => {
                    const values = [
                      option?.id,
                      option?.purchaseOrder?.purchaseOrderNumber
                        ? `SAP PO Number: ${option.purchaseOrder?.purchaseOrderNumber}`
                        : null,
                      option?.purchaseOrder?.offer?.stakeholder?.name
                        ? `Supplier: ${option.purchaseOrder?.offer?.stakeholder?.name}`
                        : null,
                      option?.purchaseOrder?.offer?.item?.origin
                        ? `Origin: ${option.purchaseOrder?.offer?.item?.origin}`
                        : null,
                      option?.purchaseOrder?.offer?.item?.buyingGrade
                        ? `Buying Grade: ${option.purchaseOrder?.offer?.item?.buyingGrade}`
                        : null,
                    ].filter((value) => value);

                    return values.join(" - ");
                  }}
                  value={shipmentRequests.filter((shipmentRequest) =>
                    filterShippingInstruction.shipmentRequestIdList.includes(
                      shipmentRequest.id,
                    ),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      shipmentRequestIdList: newValue
                        .map((shipmentRequest) => shipmentRequest.id)
                        .filter((id) => id !== null),
                    });
                  }}
                  renderOption={(props, option, { selected }) => {
                    const values = [
                      option?.id,
                      option?.purchaseOrder?.purchaseOrderNumber
                        ? `SAP PO Number: ${option.purchaseOrder?.purchaseOrderNumber}`
                        : null,
                      option?.purchaseOrder?.offer?.stakeholder?.name
                        ? `Supplier: ${option.purchaseOrder?.offer?.stakeholder?.name}`
                        : null,
                      option?.purchaseOrder?.offer?.item?.origin
                        ? `Origin: ${option.purchaseOrder?.offer?.item?.origin}`
                        : null,
                      option?.purchaseOrder?.offer?.item?.buyingGrade
                        ? `Buying Grade: ${option.purchaseOrder?.offer?.item?.buyingGrade}`
                        : null,
                    ].filter((value) => value);

                    const optionLabel = values.join(" - ");
                    return (
                      <li
                        {...props}
                        style={{
                          ...props.style,
                          backgroundColor: selected ? "lightblue" : undefined,
                          fontWeight: selected ? 700 : 400,
                        }}
                      >
                        {optionLabel}
                      </li>
                    );
                  }}
                  renderInput={(params) => {
                    const label =
                      filterShippingInstruction?.shipmentRequestIdList.length >
                      0
                        ? `Shipment Requests Selected (${filterShippingInstruction?.shipmentRequestIdList.length})`
                        : "Shipment Request";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.shipmentRequest.inputValue}
                        onChange={(e) => {
                          updateComponentState("shipmentRequest", {
                            inputValue: e.target.value,
                          });
                        }}
                        onMouseDown={() => retrieveShipmentRequests()}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("shipmentRequest", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

            <TextField
                  type="search"
                  id="outlined-select-type"
                  select
                  fullWidth
                  label="Type"
                  SelectProps={{
                    multiple: true,
                    value: filterShippingInstruction.shippingInstructionTypeList || [],
                    onChange: (e) => {
                      setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        shippingInstructionTypeList: e.target.value,
                      });
                    },
                  }}
                >
                  {shipmentRequestTypes.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

      <Autocomplete
        multiple
        id="outlined-select-item"
        disableClearable
        open={componentsState.item.dropdownOpen}
        onOpen={() => updateComponentState("item", { dropdownOpen: true })}
        inputValue={componentsState.item.inputValue}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === "input") {
            updateComponentState("item", { inputValue: newInputValue });
          }
        }}
        options={[
          ...items.filter((item) =>
            filterShippingInstruction.itemIdList.includes(item.id),
          ),
          ...items.filter(
            (item) => !filterShippingInstruction.itemIdList.includes(item.id),
          ),
        ]}
        getOptionLabel={(option) =>
          `${option?.id || ""} - ${option?.buyingGrade || ""} - ${
            option?.crop || ""
          } - ${option?.origin || ""}`
        }
        value={items.filter((item) =>
          filterShippingInstruction.itemIdList.includes(item.id),
        )}
        onChange={(event, newValue) => {
          setFilterShippingInstruction({
            ...filterShippingInstruction,
            itemIdList: newValue
            .map((item) => item.id)
            .filter((id) => id !== null),
          });
        }}
        renderOption={(props, option, { selected }) => (
          <li
            {...props}
            style={{
              ...props.style,
              backgroundColor: selected ? "lightblue" : undefined,
              fontWeight: selected ? 700 : 400,
            }}
          >
            {`${option?.id || ""} - ${option?.buyingGrade || ""} - ${
              option?.crop || ""
            } - ${option?.origin || ""}`}
          </li>
        )}
        renderInput={(params) => {
          const label =
            filterShippingInstruction?.itemIdList.length > 0
              ? `Items Selected (${filterShippingInstruction?.itemIdList.length})`
              : "Item";

          return (
            <TextField
              {...params}
              label={label}
              type="search"
              value={componentsState.item.inputValue}
              onChange={(e) =>
                updateComponentState("item", { inputValue: e.target.value })
              }
              onMouseDown={() => retrieveItems()}
              InputProps={{
                ...params.InputProps,
                style: { height: 42 },
              }}
              onBlur={() =>
                updateComponentState("item", { dropdownOpen: false })
              }
            />
          );
        }}
        renderTags={() => null}
      />

                <TextField
                  id="outlined-number"
                  label="SI Number"
                  value={
                    filterShippingInstruction?.finalShippingInstructionNumber ||
                    ""
                  }
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      finalShippingInstructionNumber: e.target.value,
                    })
                  }
                />

                <TextField
                  id="date"
                  type="date"
                  label="SI Date"
                  value={
                    filterShippingInstruction?.shippingInstructionDate || ""
                  }
                  onKeyDown={(e) => e.preventDefault()}
                  inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      shippingInstructionDate: e.target.value,
                    })
                  }
                />

                <TextField
                  label="Status"
                  type="search"
                  id="outlined-select-status"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterShippingInstruction.statusList || [],
                    onChange: (e) => {
                      setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        statusList: e.target.value,
                      });
                    },
                  }}
                >
                  {shippingInstructionStatus.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  id="date"
                  type="date"
                  label="Date Of Loading"
                  value={filterShippingInstruction?.dateOfLoading || ""}
                  onKeyDown={(e) => e.preventDefault()}
                  inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      dateOfLoading: e.target.value,
                    })
                  }
                />

                <Autocomplete
                  multiple
                  id="outlined-select-freight-offer"
                  disableClearable
                  open={componentsState.freightOffer.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("freightOffer", { dropdownOpen: true })
                  }
                  inputValue={componentsState.freightOffer.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("freightOffer", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...freightOffers.filter((freightOffer) =>
                      filterShippingInstruction.freightOfferIdList.includes(
                        freightOffer.id,
                      ),
                    ),
                    ...freightOffers.filter(
                      (freightOffer) =>
                        !filterShippingInstruction.freightOfferIdList.includes(
                          freightOffer.id,
                        ),
                    ),
                  ]}
                  getOptionLabel={(option) => {
                    const values = [
                      option?.id,
                      option?.forwarder,
                      option?.pointOfLoading,
                      option?.pointOfDischarge,
                      option?.fortyFtRate
                        ? `40Ft: ${option.fortyFtRate} ${
                            option?.fortyFtCurrency || ""
                          }`
                        : null,
                      option?.twentyFtRate
                        ? `20Ft: ${option.twentyFtRate} ${
                            option?.twentyFtCurrency || ""
                          }`
                        : null,
                      option?.transitTime
                        ? `Transit: ${option.transitTime}`
                        : null,
                    ].filter((value) => value);

                    return values.join(" - ");
                  }}
                  value={freightOffers.filter((freightOffer) =>
                    filterShippingInstruction.freightOfferIdList.includes(
                      freightOffer.id,
                    ),
                  )}
                  onChange={(event, newValue) => {
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      freightOfferIdList: newValue
                        .map((freightOffer) => freightOffer.id)
                        .filter((id) => id !== null),
                    });
                  }}
                  renderOption={(props, option, { selected }) => {
                    const values = [
                      option?.id,
                      option?.forwarder,
                      option?.pointOfLoading,
                      option?.pointOfDischarge,
                      option?.fortyFtRate
                        ? `40Ft: ${option.fortyFtRate} ${
                            option?.fortyFtCurrency || ""
                          }`
                        : null,
                      option?.twentyFtRate
                        ? `20Ft: ${option.twentyFtRate} ${
                            option?.twentyFtCurrency || ""
                          }`
                        : null,
                      option?.transitTime
                        ? `Transit: ${option.transitTime}`
                        : null,
                    ].filter((value) => value);

                    const optionLabel = values.join(" - ");

                    return (
                      <li
                        {...props}
                        style={{
                          ...props.style,
                          backgroundColor: selected ? "lightblue" : undefined,
                          fontWeight: selected ? 700 : 400,
                        }}
                      >
                        {optionLabel}
                      </li>
                    );
                  }}
                  renderInput={(params) => {
                    const label =
                      filterShippingInstruction?.freightOfferIdList.length > 0
                        ? `Freight Offers Selected (${filterShippingInstruction?.freightOfferIdList.length})`
                        : "Freight Offer";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.freightOffer.inputValue}
                        onChange={(e) => {
                          updateComponentState("freightOffer", {
                            inputValue: e.target.value,
                          });
                        }}
                        onMouseDown={() => retrieveFreightOffers()}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("freightOffer", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <TextField
                  id="outlined-number"
                  label="Transportation Contact"
                  value={filterShippingInstruction?.transportationContact || ""}
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      transportationContact: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-number"
                  label="Carton Number"
                  value={filterShippingInstruction?.cartonNumber || ""}
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      cartonNumber: e.target.value,
                    })
                  }
                />

                <TextField
                  label="To Be Shipped By"
                  type="search"
                  id="outlined-select-shipped-by"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterShippingInstruction.shippedByList || [],
                    onChange: (e) => {
                      setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        shippedByList: e.target.value,
                      });
                    },
                  }}
                >
                  {shippedBy.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  id="outlined-number"
                  label="Bill Of Lading Number"
                  value={filterShippingInstruction?.billOfLadingNumber || ""}
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      billOfLadingNumber: e.target.value,
                    })
                  }
                />

                <TextField
                  id="date"
                  type="date"
                  label="Bill Of Lading Date"
                  value={filterShippingInstruction?.billOfLadingDate || ""}
                  onKeyDown={(e) => e.preventDefault()}
                  inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      billOfLadingDate: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-number"
                  label="CMR Number"
                  value={filterShippingInstruction?.cmrNumber || ""}
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      cmrNumber: e.target.value,
                    })
                  }
                />

                <TextField
                  id="date"
                  type="date"
                  label="CMR Date"
                  value={filterShippingInstruction?.cmrDate || ""}
                  onKeyDown={(e) => e.preventDefault()}
                  inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      cmrDate: e.target.value,
                    })
                  }
                />

                <TextField
                  label="Point Of Loading"
                  type="search"
                  id="outlined-select-point-of-loading"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterShippingInstruction.pointOfLoadingList || [],
                    onChange: (e) => {
                      setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        pointOfLoadingList: e.target.value,
                      });
                    },
                  }}
                >
                  {portsOfLoading.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  label="Point Of Unloading"
                  type="search"
                  id="outlined-point-of-unloading"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterShippingInstruction.pointOfUnloadingList || [],
                    onChange: (e) => {
                      setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        pointOfUnloadingList: e.target.value,
                      });
                    },
                  }}
                >
                  {portsOfDischarge.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  id="outlined-search"
                  label="Description"
                  value={filterShippingInstruction?.description || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      description: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-search"
                  label="Remark"
                  value={filterShippingInstruction?.remark || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterShippingInstruction({
                      ...filterShippingInstruction,
                      remark: e.target.value,
                    })
                  }
                />

                <TextField
                  label="Record Status"
                  type="search"
                  id="outlined-select-status"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterShippingInstruction.recordStatusList || [],
                    onChange: (e) => {
                      setFilterShippingInstruction({
                        ...filterShippingInstruction,
                        recordStatusList: e.target.value,
                      });
                    },
                  }}
                >
                  {recordStatus.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                 <MyFilters
                   componentName="ShippingInstructionCostingView"
                   filterState={filterShippingInstruction}
                   onApply={(saved) => setFilterShippingInstruction(saved)}
                 />
                 
              </Grid>
              <br></br>
              <Grid
                container
                spacing={2}
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid item xs={3} sm={1}>
                  <Button
                    disableElevation
                    variant="contained"
                    fullWidth
                    onClick={() => {
                      retrieveFastFilteredShippingInstructionCostingApi(
                        filterShippingInstruction,
                      )
                        .then((response) => {
                          setRows(response?.data);
                        })
                        .catch((error) => {
                          console.log(error?.response?.data);
                        });
                    }}
                  >
                    Search
                  </Button>
                </Grid>
                <Grid item xs={3} sm={1}>
                  <Button
                    disableElevation
                    variant="outlined"
                    fullWidth
                    onClick={() => {
                      setFilterShippingInstruction({
                        id: 0,
                        shipmentRequestIdList: [],
                        shippingInstructionNumber: null,
                        shippingInstructionDate: "",
                        dateOfLoading: "",
                        purchaseOrderIdList: [],
                        salesOrderIdList: [],
                        shippingInstructionIdList: [],
                        itemIdList: [],
                        freightOfferIdList: [],
                        transportationContact: "",
                        cartonNumber: "",
                        finalShippingInstructionNumber: "",
                        shippedByList: [],
                        billOfLadingNumber: "",
                        billOfLadingDate: "",
                        cmrNumber: "",
                        cmrDate: "",
                        shipperIdList: [],
                        consigneeIdList: [],
                        notifyIdList: [],
                        pointOfLoadingList: [],
                        pointOfUnloadingList: [],
                        description: "",
                        remark: "",
                        statusList: [],
                        recordStatusList: ["ACTIVE"],
                      });
                    }}
                  >
                    Clear Filters
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}

          <Box sx={{ width: "100%", mt: 2 }}>
            <Paper sx={{ width: "100%", mb: 2 }}>
              <EnhancedTableToolbar
                numSelected={selected.length}
                showFilters={showFilters}
                setShowFilters={setShowFilters}
                rows={rows}
                selected={selected}
                selectedData={selectedData}
                filterShippingInstruction = {filterShippingInstruction}
                setFilterShippingInstruction = {setFilterShippingInstruction}
                setRows  = {setRows}
              />
              <TableContainer style={{ maxHeight: 700 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  sx={{
                    minWidth: 750,
                    "& .MuiTableCell-root": {
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                    },
                    "& .MuiTableCell-head": {
                      backgroundColor: "#20315d",
                      color: "white",
                      borderRight: "1px solid rgba(49, 64, 128, 1)",
                    },
                  }}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                  style={{ width: "max-content" }}
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={rows.length}
                  />
                  <TableBody>
                    {visibleRows.map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          style={
                            isSelected(row.id)
                              ? { background: "#d7e7fc" }
                              : row?.status === "Closed"
                              ? { background: "#c8e6c9" }
                              : index % 2
                              ? { background: "#f0f0f0" }
                              : { background: "white" }
                          }
                          hover
                          onClick={(event) => handleClick(event, row.id, row)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.id}
                          selected={isItemSelected}
                          sx={{ cursor: "pointer" }}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              checked={isItemSelected}
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                            />
                          </TableCell>
                          <TableCell padding="normal">
                          <Button
                           onClick={(e) => {
                           setSelectedRow(row);
                           setIsEditShippingCostDialogOpen(true);
                           e.preventDefault();
                           }}
                          >
                           Edit Costs
                          </Button>
                          </TableCell>
                         <TableCell align="center">
                           <IconButton onClick={() => openViewDialog(row)}><MonetizationOnIcon/></IconButton>
                         </TableCell>
                          <TableCell align="center">
                            <ShippingInstructionHistoryButton
                              fetchHistoryApi={retrieveFilteredShippingInstructionsApi}
                              currentRow={row}
                            />
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              position: "sticky",
                              left: 0,
                              background: "inherit",
                              zIndex: 1,
                            }}
                          >
                            {row?.id}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shipmentRequestType}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shipmentQuantity
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(
                                  row.shipmentQuantity,
                                )} ${
                                  row?.shipmentQuantityUnit
                                }`
                              : ""}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              position: "sticky",
                              left: 50,
                              background: "inherit",
                              zIndex: 1,
                            }}
                          >
                            {row?.finalShippingInstructionNumber}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shippingInstructionDate
                              ? format(
                                  new Date(row?.shippingInstructionDate),
                                  "dd/MM/yyyy",
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.actualTimeOfArrival
                              ? format(
                                  new Date(row?.actualTimeOfArrival),
                                  "dd/MM/yyyy",
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.purchaseOrderId}
                          </TableCell>
                          <TableCell align="center">
                            {row?.purchaseOrderCompany}
                          </TableCell>
                          <TableCell align="center">
                            {
                              row?.purchaseOrderNumber
                            }
                          </TableCell> 
                          <TableCell align="center">
                            {row?.salesOrderId}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesOrderCompany}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesOrderNumber}
                          </TableCell>
                          <TableCell align="center">{row?.salesOrderFinalPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 4,
                                }).format(row?.salesOrderFinalPrice)} ${row?.salesOrderFinalPriceCurrency || ""}` 
                              : ""}{" "}
                            </TableCell>
                          <TableCell align="center">
                            {row?.salesOrderItemId ||
                              row?.purchaseOrderItemId ||
                              ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesOrderItemBuyingGrade ||
                              row?.purchaseOrderItemBuyingGrade ||
                              ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shipmentRequestCustomerGradeMark}
                          </TableCell>
                          <TableCell align="center">
                            {row?.purchaseOrderItemCrop || row?.salesOrderItemCrop}
                          </TableCell>
                          <TableCell align="center">{row?.warehouse}</TableCell>
                          <TableCell align="center">
                            {row?.destination}
                          </TableCell>
                          <TableCell align="center">
                            {row?.pointOfLoading}
                          </TableCell>
                          <TableCell align="center">
                            {row?.pointOfUnloading}
                          </TableCell>
                          <TableCell align="center">
                            {row?.freightOfferId}
                          </TableCell>
                          <TableCell align="center">{row?.purchaseOrderFinalPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 4,
                                }).format(row?.purchaseOrderFinalPrice)} ${row?.purchaseOrderFinalPriceCurrency || ""}` 
                              : ""}{" "}
                            </TableCell>
                            <TableCell align="center">{row?.purchaseOrderUsdFinalPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 4,
                                }).format(row?.purchaseOrderUsdFinalPrice)} USD` 
                              : ""}{" "}
                            </TableCell>
                            <TableCell align="center">{row?.actualBuyingPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 4,
                                }).format(row?.actualBuyingPrice)} ${row?.actualBuyingPriceCurrency || ""}` 
                              : ""}{" "}
                            </TableCell>
                            <TableCell align="center">{row?.actualBuyingPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 4,
                                }).format(row?.actualBuyingPriceUsd)} USD` 
                              : ""}{" "}
                            </TableCell>
                            <TableCell align="center">{row?.actualBuyingPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 4,
                                }).format(row.actualBuyingPrice? row?.shipmentQuantity ? (row?.actualBuyingPrice * row?.shipmentQuantity): 0 :0)} ${row?.actualBuyingPriceCurrency || ""}` 
                              : ""}{" "}
                            </TableCell>
                            <TableCell align="center">{row?.actualBuyingPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 4,
                                }).format(row.actualBuyingPriceUsd? row?.shipmentQuantity ? (row?.actualBuyingPriceUsd * row?.shipmentQuantity): 0 :0)} USD` 
                              : ""}{" "}
                            </TableCell>
                          <TableCell align="center">{row?.actualFreightPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 4,
                                }).format(row?.actualFreightPrice)} ${row.actualFreightCurrency || ""}` 
                              : ""}{" "}
                            </TableCell>
                            <TableCell align="center">{row?.actualFreightPriceUsd
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 4,
                                }).format(row?.actualFreightPriceUsd)} USD` 
                              : ""}{" "}
                            </TableCell>
                          <TableCell align="center">{row?.actualInsuranceCost
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 4,
                                }).format(row?.actualInsuranceCost)} ${row.actualInsuranceCurrency || ""}` 
                              : ""}{" "}
                            </TableCell>
                            <TableCell align="center">{row?.actualInsuranceCostUsd
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 4,
                                }).format(row?.actualInsuranceCostUsd)} USD` 
                              : ""}{" "}
                            </TableCell>
                            <TableCell align="center">{row?.baseStorageCost
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 4,
                                }).format(row?.baseStorageCost)}` 
                              : ""}{" "}
                            </TableCell>
                            <TableCell align="center">{row?.baseStorageCostUsd
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 4,
                                }).format(row?.baseStorageCostUsd)}` 
                              : ""}{" "}
                            </TableCell>
                            <TableCell align="center">{row?.actualStorageCost
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 4,
                                }).format(row?.actualStorageCost)} USD ${
                                  row.actualStoragePricing ? "Per "+row.actualStoragePricing : ""
                                }`
                              : ""}
                            </TableCell>
                                <TableCell align="center">
                                  {row?.actualStoragePricing === "Carton" && row?.actualStorageCost && row?.shipmentRequestNetWeightPerCase
                                    ? `${new Intl.NumberFormat("en-US", {
                                        style: "decimal",
                                        minimumFractionDigits: 4,
                                      }).format(row.actualStorageCost / row.shipmentRequestNetWeightPerCase)} USD`
                                    : row?.actualStorageCost
                                    ? `${new Intl.NumberFormat("en-US", {
                                        style: "decimal",
                                        minimumFractionDigits: 4,
                                      }).format(row.actualStorageCost)} USD`
                                    : ""}
                                </TableCell>
                                <TableCell align="center">
                                  {(() => {
                                    const freight = row?.actualFreightPriceUsd ? Number(row.actualFreightPriceUsd) : 0;
                                    const insurance = row?.actualInsuranceCostUsd ? Number(row.actualInsuranceCostUsd) : 0;
                                  
                                    const finalPrice = row?.actualBuyingPriceUsd ? 
                                      Number(row.actualBuyingPriceUsd)
                                      : row?.purchaseOrderUsdFinalPrice
                                      ? Number(row.purchaseOrderUsdFinalPrice)
                                      : 0;

                                    const secondFreight = row?.secondFreightCostUsd
                                      ? Number(row.secondFreightCostUsd)
                                      : 0;

                                    const importExportExpense = row?.importExportExpenseUsd
                                      ? Number(row.importExportExpenseUsd)
                                      : 0;

                                      const demurrage = row?.demurrageUsd
                                      ? Number(row.demurrageUsd)
                                      : 0;

                                      const fumigation = row?.fumigationUsd
                                      ? Number(row.fumigationUsd)
                                      : 0;

                                      const handling = row?.handlingUsd
                                      ? Number(row.handlingUsd)
                                      : 0;

                                      const debitNote = row?.debitNoteUsd
                                      ? Number(row.debitNoteUsd)
                                      : 0;

                                      const creditNote = row?.creditNoteUsd
                                      ? -Number(row.creditNoteUsd)
                                      : 0;

                                    const total = freight + insurance  + finalPrice + secondFreight + importExportExpense + demurrage + fumigation + debitNote + handling + creditNote;
                                  
                                    return total > 0
                                      ? new Intl.NumberFormat("en-US", {
                                          style: "decimal",
                                          minimumFractionDigits: 4,
                                        }).format(total) + " USD"
                                      : "";
                                  })()}
                                </TableCell>
                                <TableCell align="center">
                                  {(() => {
                                    const freight = row?.actualFreightPriceUsd ? Number(row.actualFreightPriceUsd) : 0;
                                    const insurance = row?.actualInsuranceCostUsd ? Number(row.actualInsuranceCostUsd) : 0;
                                    const storage = row?.actualStorageCost
                                      ? row?.actualStoragePricing === "Carton" && row?.shipmentRequestNetWeightPerCase
                                        ? Number(row.actualStorageCost) / Number(row.shipmentRequestNetWeightPerCase)
                                        : Number(row.actualStorageCost)
                                      : 0;
                                  
                                    const finalPrice = row?.actualBuyingPriceUsd ? 
                                       Number(row.actualBuyingPriceUsd)
                                      : row?.purchaseOrderUsdFinalPrice
                                      ? Number(row.purchaseOrderUsdFinalPrice)
                                      : 0;

                                    const secondFreight = row?.secondFreightCostUsd
                                      ? Number(row.secondFreightCostUsd)
                                      : 0;

                                    const importExportExpense = row?.importExportExpenseUsd
                                      ? Number(row.importExportExpenseUsd)
                                      : 0;

                                      const demurrage = row?.demurrageUsd
                                      ? Number(row.demurrageUsd)
                                      : 0;

                                      const fumigation = row?.fumigationUsd
                                      ? Number(row.fumigationUsd)
                                      : 0;

                                      const handling = row?.handlingUsd
                                      ? Number(row.handlingUsd)
                                      : 0;

                                      const debitNote = row?.debitNoteUsd
                                      ? Number(row.debitNoteUsd)
                                      : 0;

                                      const creditNote = row?.creditNoteUsd
                                      ? -Number(row.creditNoteUsd)
                                      : 0;

                                    const total = freight + insurance + storage + finalPrice + secondFreight + importExportExpense + demurrage + fumigation + handling +debitNote + creditNote;
                                  
                                    return total > 0
                                      ? new Intl.NumberFormat("en-US", {
                                          style: "decimal",
                                          minimumFractionDigits: 4,
                                        }).format(total) + " USD"
                                      : "";
                                  })()}
                                </TableCell>
                          <TableCell align="center">
                            {row?.shipmentRequestNumberOfCases}
                          </TableCell>
                          <TableCell align="center">
                            {row?.shipmentRequestNetWeightPerCase}
                          </TableCell>
                          <TableCell align="center">{row?.remark}</TableCell> 
                          <TableCell align="center">
                          {
                              row?.shipmentRequestreferenceShippingInstructionId
                            }-{
                              row?.shipmentRequestreferenceShippingInstructionNumber
                            }
                          </TableCell>
                          <TableCell align="center">{row?.status}</TableCell>
                          <TableCell align="center">
                            {row?.timestamp
                              ? format(
                                  new Date(row.timestamp),
                                  "dd/MM/yyyy HH:mm",
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="center">{row?.creator}</TableCell>
                          <TableCell align="center">
                            {row?.recordStatus}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow
                        style={{
                          height: (dense ? 33 : 53) * emptyRows,
                        }}
                      >
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <div style={{ marginTop: "20px", marginLeft: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "20px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span
                      style={{
                        background: "#c8e6c9",
                        padding: "4px 8px",
                        marginRight: "5px",
                        borderRadius: "8px",
                        display: "inline-block",
                      }}
                    >
                      Closed
                    </span>
                    <span>- SI Closed</span>
                  </div>
                </div>
              </div>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
            <FormControlLabel
              control={<Switch checked={dense} onChange={handleChangeDense} />}
              label="Dense padding"
            />
          </Box>
          <ViewShippingInstructionCostingDialog open={viewDialogOpen} row={viewRow} onClose={closeViewDialog} />
          <EditShippingInstructionCostDialog
  open={isEditShippingCostDialogOpen}
  onClose={() => setIsEditShippingCostDialogOpen(false)}
  rowData={selectedRow}
  onUpdated={() => {
    retrieveFastFilteredShippingInstructionCostingApi(filterShippingInstruction)
      .then((response) => {
        setRows(response?.data);
      })
      .catch((error) => {
        console.log(error?.response?.data);
      });
  }}
/>;
        </>
    </div>
  );
}
